<template>
  <div :class="{'option': true, 'playModeScale': scaleMode == 'playMode'}" v-if="TokenState && !iframe">
    <router-link to="/main">
      <button @click="onClick">
        <div class="icon-box">
          <font-awesome-icon :icon="['fas', 'stream']" class="icon" />
        </div>
        <div class="label-box">
          Dialogues
        </div>
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'DialoguesButton',
  props: {
    scaleMode: String,
    searchInputState: Boolean
  },
  data() {
    return {
      iframe: false
    }
  },
  methods: {
    onClick() {
      if(this.searchInputState) {
        this.$emit('closeSearchInput');
        this.$emit('closeSearch');
      } else if(this.$route.name == 'Main') {
        this.$emit('reload');
      }
    }
  },
  computed: {
    TokenState() {
      if(localStorage.getItem('token')) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if(window.location !== window.parent.location) {
      this.iframe = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.option {
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  a {
    text-decoration: none;
  }

  button {
    width: auto;
    height: 2.5rem;
    display: flex;
    transition: 0.3s;
    background: none;
    outline: none;
    border: none;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }

  .icon-box {
    width: 2.5rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      color: white;
      font-size: 1.3rem;
    }
  }

  .label-box {
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 0.2rem;
    padding-right: 0.5rem;
    color: white;
    font-size: 1.3rem;
    font-weight: bold;

    @media (max-width: 600px) {
      display: none;
    }
  }
}

.playModeScale {
  .label-box {
    @media (max-width: 1200px) {
      display: none;
    }
  }
}
</style>